var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Typography } from "@mui/material";
import { useCompany } from "../CompanyProvider/CompanyProvider";
import { useNavigate } from "react-router-dom-v5-compat";
import { isValidUrl } from "./navigationUtils";
import { getPickupLocation, validatePostalCode } from "../../../Account/utils/requests";
import { useLogging } from "../../hooks/useLogging/useLogging";
import { LogLevel } from "../../hooks/useLogging/Logging-types";
export const OrderNowButton = (_a) => {
    var props = __rest(_a, []);
    const { doesCompanyHaveOrderPage, orderNowLink, navOrderButtonText } = useCompany();
    if (!doesCompanyHaveOrderPage) {
        return null;
    }
    const navigate = useNavigate();
    const { datadogLog } = useLogging();
    function orderNowClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const orderNowLinkWithProtocol = orderNowLink.indexOf("http") === -1 ? `https://${orderNowLink}` : orderNowLink;
            if (!isValidUrl(orderNowLinkWithProtocol)) {
                return;
            }
            const currentLocationUrl = new URL(window.location.href);
            const orderNowLinkUrl = new URL(orderNowLinkWithProtocol);
            const isSameBaseUrl = currentLocationUrl.host === orderNowLinkUrl.host;
            const isOrderFlowLink = orderNowLinkUrl.pathname.includes("OrderFlow");
            if (isSameBaseUrl && isOrderFlowLink) {
                let location = null;
                let postalCode = null;
                const params = [
                    {
                        key: "location",
                        func: getPickupLocation,
                        logWarning: "Failed to fetch location for order now link",
                        logError: "Error fetching location on order now link"
                    },
                    {
                        key: "postalcode",
                        func: validatePostalCode,
                        logWarning: "Failed to validate postal code for order now link",
                        logError: "Error validating postal code on order now link"
                    }
                ];
                yield Promise.all(params.map(({ key, func, logWarning, logError }) => __awaiter(this, void 0, void 0, function* () {
                    const paramValue = orderNowLinkUrl.searchParams.get(key);
                    if (paramValue) {
                        yield func(paramValue)
                            .then((res) => {
                            if (res.data.success) {
                                if (key === "location") {
                                    location = res.data.location;
                                }
                                else if (key === "postalcode") {
                                    postalCode = paramValue;
                                }
                            }
                            else {
                                console.warn(logWarning);
                                datadogLog(logWarning, LogLevel.WARN, { [key]: paramValue });
                            }
                        })
                            .catch(() => {
                            console.error(logError);
                            datadogLog(logError, LogLevel.ERROR, { [key]: paramValue });
                        });
                    }
                })));
                navigate(orderNowLinkUrl.pathname, {
                    state: { location: location, postalCode: postalCode }
                });
            }
            else {
                window.location.replace(orderNowLinkUrl.href);
            }
        });
    }
    return (_jsx(Button, Object.assign({ onClick: orderNowClick, variant: "outlined", color: "primary" }, props, { children: _jsx(Typography, Object.assign({ variant: "h4", textTransform: "none" }, { children: navOrderButtonText })) })));
};
